<script>
import resources from './resources'

export default {
  name: 'favorite',
  mixins: [resources]
}
</script>

<template lang="pug">
  a.mb-cursor-point(@click.prevent="favoriteProfessional(professional)")
    li
      i.fa.fa-heart-o(aria-hidden='true', style="margin-left: 10px; color: #194c7c; font-size: 16px")
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/favorite/favorite.vue